import React from "react";
//#region types
import { GenericFormSection, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { SurveyFormProps } from "models/propTypes/surveyPropsTypes";
//#endregion
//#region components
import { GenericForm, useDynamicFormDefinition } from "components/common";
import { useSurveyService } from "serviceHooks";
//#endregion

const SurveyForm: React.ForwardRefRenderFunction<FormHandles, SurveyFormProps> = (props, ref) => {
  const surveyService = useSurveyService();
  const { questionGroups } = props;

  const getFileContent = (id: string | number) => surveyService.getFileContent(id as string);

  const { getSections } = useDynamicFormDefinition(questionGroups, getFileContent);

  const formFields: GenericFormSection<any>[] = getSections(FormEnums.FormSectionType.WIZARDTAB);
  return <GenericForm formRef={ref} {...props} fields={formFields} isReadOnly={props.isFinal} inline={props.isFinal} />;
};

export default React.forwardRef(SurveyForm);
